import { ReduxStoreType } from '../../@types';

export const getUserData = (store: ReduxStoreType) => store.auth.userData;
export const getAuthError = (store: ReduxStoreType) => store.auth.error;
